module.exports = __webpack_public_path__ + "static/media/group.2365d16e.svg";